<template>
  <img :key="source" :src="source" :data-playlist-artwork="playlistId" :data-artwork-state="candidate ? 'source' : 'fallback'" v-bind="$attrs" @error="onError" />
</template>
<script>
import { runtime } from '../bridge';
import { playlistArtworkCandidates } from '../playlist-artwork';
export default {
  name: 'PlaylistArtwork', inheritAttrs: false,
  props: { playlistId: { type: String, required: true } },
  data() { return { state: runtime.state, failed: [] }; },
  computed: {
    playlist() { return this.state.playlists.find(item => item.id === this.playlistId); },
    candidates() { return this.playlist ? playlistArtworkCandidates(this.playlist, this.state.tracks, runtime.coverCandidate) : []; },
    revision() { return JSON.stringify([this.playlistId, this.playlist?.coverUpdatedAt, this.candidates]); },
    candidate() { return this.candidates.find(url => !this.failed.includes(url)) || ''; },
    source() { return this.candidate || runtime.cover(); },
  },
  watch: { revision() { this.failed = []; } },
  methods: { onError(event) { if (this.candidate && event.target.getAttribute('src') === this.source) this.failed = [...this.failed, this.candidate]; } },
};
</script>
